import { useMemo } from 'react';

import { useGetCustomerConfigurations } from 'api';

import { useOrganisationId } from 'hooks/context';

export type CryptoWidgetVariant = 'c2c' | 'bigedirect';

const VALID_VARIANTS: Record<string, CryptoWidgetVariant> = {
  c2c: 'c2c',
  bigedirect: 'bigedirect'
};

export const useCryptoWidgetVariant = () => {
  const organisationId = useOrganisationId<number>();

  const { data: { data: orgSettings } = {}, isLoading } =
    useGetCustomerConfigurations(organisationId);

  const cryptoWidgetVariant = useMemo(
    () => VALID_VARIANTS[orgSettings?.crypto_widget_variant ?? ''],
    [orgSettings?.crypto_widget_variant]
  );

  return { cryptoWidgetVariant, isLoading };
};
